/**
 * Copyright (C) 2023 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import React from 'react';
import isNil from 'lodash/isNil';
import NumberFormat from 'react-number-format';
import { shallowEqual, useSelector } from 'react-redux';
import { selectTickets } from '../../store';
import { TicketsState } from '../../store/tickets/reducer';

export type TicketsTablePageNumberInputType = {
  target: {
    name: string;
    value: string;
  };
};

// From https://v4.mui.com/components/text-fields/#integration-with-3rd-party-input-libraries
export interface NumberFormatCustomProps {
  inputRef: (instance: NumberFormat<string> | null) => void;
  onChange: (event: TicketsTablePageNumberInputType) => void;
  name: string;
}

function NumberFormatCustom(props: NumberFormatCustomProps) {
  const { inputRef, onChange, ...other } = props;
  const tickets: TicketsState = useSelector(selectTickets, shallowEqual);
  const ticketsPerPage = (tickets.options || {}).limit;
  const totalTickets = tickets.total || 1;
  const maxPage = ticketsPerPage ? Math.ceil(totalTickets / ticketsPerPage) : 999999;
  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      decimalScale={0}
      allowNegative={false}
      isAllowed={values => {
        const { floatValue } = values;
        if (isNil(floatValue)) {
          return true;
        } else {
          return floatValue >= 1 && floatValue <= maxPage;
        }
      }}
      onValueChange={values => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      isNumericString
    />
  );
}
export default NumberFormatCustom;
